import { useQuery } from '@tanstack/react-query'
import { RefreshCw, CheckCircle, AlertTriangle } from 'lucide-react'
import { api } from '../../utils/api'
import { jiraChromeVisible, JIRA_OUTBOX_QUERY_KEY, type JiraOutboxStatus } from './jiraChrome.logic'

export function JiraSyncBadge() {
  const { data } = useQuery<JiraOutboxStatus>({
    queryKey: JIRA_OUTBOX_QUERY_KEY,
    queryFn: () => api.get('/api/integrations/jira/outbox/status').then(r => r.data),
    refetchInterval: 10000,
  })

  if (!jiraChromeVisible(data)) return null

  if ((data.failed_count ?? 0) > 0) {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 bg-status-critical/10 text-status-critical rounded-full border border-status-critical/20 text-xs font-medium backdrop-blur-md" title={`${data.failed_count} failed updates`}>
        <AlertTriangle className="w-3 h-3" />
        <span>Jira: {data.failed_count} Failed</span>
      </div>
    )
  }

  if ((data.pending_count ?? 0) > 0) {
    return (
      <div className="flex items-center gap-1.5 px-2 py-1 bg-status-warning/10 text-status-warning rounded-full border border-status-warning/20 text-xs font-medium backdrop-blur-md" title={`${data.pending_count} pending updates`}>
        <RefreshCw className="w-3 h-3 animate-spin" />
        <span>Syncing ({data.pending_count})</span>
      </div>
    )
  }

  return (
    <div className="flex items-center gap-1.5 px-2 py-1 bg-status-normal/10 text-status-normal rounded-full border border-status-normal/20 text-xs font-medium backdrop-blur-md" title="Jira Workspaces Synced">
      <CheckCircle className="w-3 h-3" />
      <span>Jira: Synced</span>
    </div>
  )
}
